import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import { accountingProviders } from '~/lookups';
import React from 'react';

export default function ReloadPaymentFromAccountingDialog({ payment, accountingProvider, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const accountingProviderName = accountingProviders[accountingProvider].name;
  const connectionName = payment.accountingConnectionName || accountingProviderName;

  const handleSubmit = async () => {
    form.submit();

    try {
      await api.www.workspaces(workspace.id).clientPayments(payment.id)[`loadFrom${accountingProviderName}`]();
      await resolve();
      toast.success(`The payment has been reloaded from ${accountingProviderName}.`);
    } catch (error) {
      toast.error(
        error.message ?? `An error has occurred. The payment has not been reloaded from ${accountingProviderName}.`,
      );
      form.done();
    }
  };

  return (
    <ModalCard title={`Reload from ${accountingProviderName}`} onClose={() => resolve(false)}>
      <ModalCard.Body>{`Are you sure you want to reload this payment from ${connectionName}?`}</ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Reload
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
